<template>
  <div style="margin-top: 2rem">
    <h5 class="mb-4">
      <span>Month Total: </span>
      <b-badge>{{ monthTotal }}</b-badge>
    </h5>

    <b-row v-if="promoCodePartnerItems.length > 0" class="mr-0 mt-4">
      <b-col>
        <h5 style="margin-bottom: 2rem; margin-top: 2rem">Partner Totals</h5>

        <b-table
          class="mt-3"
          :items="promoCodePartnerItems"
          :fields="partnerFields"
          ref="table"
          striped
          :per-page="perPagePartner"
          :current-page="currentPagePartner"
        >
        </b-table>

        <div v-if="perPagePartner" class="d-flex justify-content-center">
          <b-pagination
            :total-rows="promoCodePartnerItems.length"
            :per-page="perPagePartner"
            v-model="currentPagePartner"
          />
        </div>
      </b-col>
      <b-col> </b-col>
    </b-row>

    <h5 style="margin-top: 4rem">Records</h5>
    <div
      id="user-count-stats"
      class="d-flex justify-content-between align-items-center my-4"
    >
      <b-form inline class="">
        <label class="mr-sm-2" for="rev-share-select-partner">Partner</label>
        <b-form-select
          class="mr-2"
          id="rev-share-select-partner"
          :value="selectedPartner"
          @input="updatePartner($event)"
          :options="partnerOptions"
        ></b-form-select>
      </b-form>

      <b-button variant="primary" @click="exportRecords">
        <Icon2 icon="export" />
        Export Records
      </b-button>
    </div>

    <b-table
      class="mt-3"
      :items="promoCodeItems"
      :fields="recordFields"
      ref="table"
      striped
      hover
      small
      :per-page="perPage"
      :current-page="currentPage"
    />

    <div v-if="perPage" class="d-flex justify-content-center">
      <b-pagination
        :total-rows="promoCodeItems.length"
        :per-page="perPage"
        v-model="currentPage"
      />
    </div>

    <iframe id="export-promo-codes-frame" style="display: none"></iframe>
  </div>
</template>

<script>
export default {
  name: "PromoCodeOverview",

  data: function () {
    return {
      partnerFields: [
        { key: "partner", label: "Partner", sortable: true },
        {
          key: "count",
          label: "Number of Discounts",
          sortable: true,
          tdClass: "text-right",
        },
        {
          key: "amount",
          label: "Discount Amount (€)",
          sortable: true,
          formatter: this.$helpers.currencyFormatter,
          tdClass: "text-right",
        },
      ],

      recordFields: [
        { key: "code", label: "Promo Code", sortable: true },
        { key: "partner", label: "Partner", sortable: true },
        { key: "offer", label: "Offer", sortable: true },
        { key: "geo", label: "Country", sortable: true },
        { key: "user", label: "User", sortable: true },
        {
          key: "amount",
          label: "Amount (€)",
          sortable: true,
          formatter: this.$helpers.currencyFormatter,
          tdClass: "text-right",
        },
        {
          key: "inserted_at",
          label: "Created At",
          sortable: true,
          formatter: this.$helpers.dtFormatter,
        },
      ],

      currentPage: 1,
      perPage: 20,

      currentPagePartner: 1,
      perPagePartner: 20,

      partnerOptions: [],
      selectedPartner: "*",
    };
  },

  computed: {
    monthTotal() {
      let total = 0;
      this.promoCodePartnerItems.forEach((item) => (total += item.amount));

      return this.$helpers.currencyFormatter(total);
    },

    selectedYear() {
      return this.$store.state.finance.selectedYear;
    },

    selectedMonth() {
      return this.$store.state.finance.selectedMonth;
    },

    promoCodeItems() {
      return this.$store.state.finance.promoCodeItems.filter(
        (rec) =>
          this.selectedPartner == "*" || rec.partner_id == this.selectedPartner
      );
    },

    promoCodePartnerItems() {
      return this.$store.state.finance.promoCodePartnerItems.filter(
        (item) => item.amount != 0 || item.count != 0
      );
    },
  },

  methods: {
    getProviderOptions() {
      fetch("/admin/api/v2/partners/select-options?include-all")
        .then(this.$helpers.JSONHandler)
        .then((resp) => {
          this.partnerOptions = resp.data;
        });
    },

    updatePartner(partner) {
      this.selectedPartner = partner;
    },

    exportRecords() {
      let payload = {
        data: {
          year: this.params.selectedYear,
          month: this.params.selectedMonth,
          partner_id: this.selectedPartner,
        },
      };

      this.$http.postJSON(
        "/admin/api/v2/promo-codes/build-export",
        payload,
        (resp) => {
          let file_name =
            "/admin/api/v2/promo-codes/download-export/" + resp.data;
          document.getElementById("export-promo-codes-frame").src = file_name;
        },
        (status, html) => {
          this.clear();
          this.$root.app.showErrorDialog(html, status.toString());
        }
      );
    },
  },

  created() {
    this.getProviderOptions();
    this.$root.$on("rev-share-update", this.update);
  },

  beforeDestroy() {
    this.$root.$off("rev-share-update", this.update);
  },
};
</script>

<style scoped></style>
